package com.trevorwiebe.timesheet.mileage.domain.usecases

import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.mileage.domain.LocationRepository
import com.trevorwiebe.timesheet.mileage.domain.MileageRepository
import com.trevorwiebe.timesheet.mileage.domain.model.Location
import com.trevorwiebe.timesheet.mileage.domain.model.MileageEntry
import com.trevorwiebe.timesheet.mileage.domain.model.TripTypeData

class UpdateMileageEntry(
    private val mileageRepository: MileageRepository,
    private val locationRepository: LocationRepository
) {
    suspend fun invoke(entry: MileageEntry, newLocation: Location?): TSResult {
        val finalEntry = if (newLocation != null) {
            val locationResult = locationRepository.addLocation(newLocation)
            if (!locationResult.error.isNullOrEmpty()) return locationResult
            val locationId = locationResult.data as String
            val updatedData = when (val data = entry.tripTypeData) {
                is TripTypeData.Loading -> data.copy(locationId = locationId)
                is TripTypeData.Unloading -> data.copy(locationId = locationId)
                is TripTypeData.Fuel -> data.copy(locationId = locationId)
                is TripTypeData.Other -> data.copy(locationId = locationId)
                else -> entry.tripTypeData
            }
            entry.copy(tripTypeData = updatedData)
        } else {
            entry
        }
        return mileageRepository.updateMileageEntry(finalEntry)
    }
}
